import clsx from 'clsx';
import React from 'react';
import { PulseLoader } from 'react-spinners';

import classes from './Button.module.scss';

const ButtonVariant = {
    Green: 'green',
    Black: 'black',
    Primary: 'primary',
    UnderlinedLink: 'underlined-link',
    Link: 'link'
} as const;

const ButtonSize = {
    Small: 'small',
    Medium: 'medium',
    Large: 'large'
} as const;

type ButtonSize = (typeof ButtonSize)[keyof typeof ButtonSize];
type ButtonVariant = (typeof ButtonVariant)[keyof typeof ButtonVariant];

interface ButtonProps extends React.ComponentProps<'button'> {
    fullWidth?: boolean;
    loading?: boolean;
    disabled?: boolean;
    variant?: ButtonVariant;
    size?: ButtonSize;
}

export const Button: React.FC<ButtonProps> = ({ variant, fullWidth, size, loading, ...props }) => {
    return (
        <button
            {...props}
            type="button"
            className={clsx(
                props.className,
                classes.root,
                classes[variant || ButtonVariant.Primary],
                classes[size || ButtonSize.Large],
                {
                    [classes.loading]: loading,
                    [classes.fullWidth]: fullWidth
                }
            )}
        >
            {props.children}

            {loading && (
                <div className={classes.loadingIcon}>
                    <PulseLoader color="#ffffff" size={8} />
                </div>
            )}
        </button>
    );
};
